@if (_dataSource) {
  <nx-tree [dataSource]="_dataSource" [treeControl]="_treeControl">
    <nx-tree-node *nxTreeNodeDef="let node">
      <button
        nxAction
        nxTreeNodeActionItem
        nxTreeNodePadding
        nxTreeNodePaddingOffset="40"
        [title]="node.label"
        type="button">
        @if (node.url) {
          <a [href]="node.url" target="_blank">{{ node.label }}</a>
        } @else {
          {{ node.label }}
        }
      </button>
    </nx-tree-node>
    <nx-tree-node *nxTreeNodeDef="let node; when: _hasChild">
      <button
        nxAction
        nxTreeNodeActionItem
        nxTreeNodeToggle
        nxTreeNodePadding
        nxTreeNodePaddingOffset="40"
        expandable
        [expanded]="_treeControl.isExpanded(node)"
        title="{{ node.label }}"
        type="button">
        @if (node.url) {
          <a [href]="node.url" target="_blank">{{ node.label }}</a>
        } @else {
          {{ node.label }}
        }
      </button>
    </nx-tree-node>
  </nx-tree>
}
